var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMutualfundOrder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.97379 0.921155V15.2896M0.552734 7.92116H2.02642M0.552734 10.8685H2.02642M0.552734 4.97379H2.02642M7.55273 3.86852H11.2369M7.55273 6.44747H11.2369M1.28958 4.97379C1.28958 2.89 1.28958 1.84737 1.93726 1.20042C2.58421 0.552734 3.62684 0.552734 5.71063 0.552734H10.1317C12.2155 0.552734 13.2581 0.552734 13.9051 1.20042C14.5527 1.84737 14.5527 2.89 14.5527 4.97379V10.8685C14.5527 12.9523 14.5527 13.9949 13.9051 14.6419C13.2581 15.2896 12.2155 15.2896 10.1317 15.2896H5.71063C3.62684 15.2896 2.58421 15.2896 1.93726 14.6419C1.28958 13.9949 1.28958 12.9523 1.28958 10.8685V4.97379Z",
    stroke: "currentColor",
    strokeWidth: 1.10526,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMutualfundOrder);
export default __webpack_public_path__ + "static/media/mutualfundOrder.e37ce2c1aa09a950fe170dc097f4c0d0.svg";
export { ForwardRef as ReactComponent };